import React, { memo } from 'react';

interface SmallDataBoxProps {
    label: string;
    value: string | number;
    colorScheme: 'green' | 'blue' | 'yellow' | 'red' | 'gray';
    isLoading?: boolean;
}

const SmallDataBox: React.FC<SmallDataBoxProps> = ({ label, value, colorScheme = 'gray', isLoading = false }) => {

    const typeClasses = {
        green: 'text-green-500',
        blue: 'text-blue-500',
        yellow: 'text-low-500',
        red: 'text-red-500',
        gray: 'text-gray-500',
    }[colorScheme]

    return (
        <div className={`flex flex-col items-center border border-gray-200 rounded-md text-center overflow-hidden ${isLoading ? 'animate-pulse bg-gray-400' : 'bg-white'}`}>
            <div className={`text-md md:text-lg font-bold leading-8 md:leading-10 h-8 md:h-10 text-gray-700 w-full text-nowrap ${isLoading}`}>{isLoading ? `` : label}</div>
            <div className={`font-bold text-xl md:text-2xl h-12 md:h-10 ${typeClasses}`}>{isLoading ? `` : value}</div>
        </div>
    )
}

export default memo(SmallDataBox);
